import dynamic from "next/dynamic";
import { Fragment, type HTMLAttributes } from "react";
import { firstUpper } from "./utils";
import { getGalleryUrl } from "@/lib/gallery";

interface BreadCrumbsProps extends HTMLAttributes<HTMLDivElement> {
  segments: {
    title: string;
    url?: string;
  }[];
}

const Link = dynamic(() => import("@/components/ui/Link"));

export default function BreadCrumbs({ segments }: BreadCrumbsProps) {
  return (
    <div className={"text-primary text-sm font-greycliff"}>
      <Link href={getGalleryUrl() || "#"} className="hover:underline">
        Gallery
      </Link>
      {" / "}
      {segments.map((segment, index) => {
        return (
          <Fragment key={segment.title}>
            {segment.url ? (
              <Link href={segment.url || "#"} className="hover:underline">
                {firstUpper(segment.title)}
              </Link>
            ) : (
              <span>{firstUpper(segment.title)}</span>
            )}
            {index < segments.length - 1 && " / "}
          </Fragment>
        );
      })}
    </div>
  );
}
